import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Button, Form, Row, Field } from '@smartplatform/ui';
import { Editor } from '../../components';
import store from '../../store';

@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;
	@observable htmlMode = true;

	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Itogi.findById(this.id);
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Itogi();
		}
	};
	
	switchMode = () => this.htmlMode = !this.htmlMode;
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		return <>
			<p>Страница</p>
			<Form record={this.record} rootPath="/admin" returnTo="/admin/itogi">
				<Field property="title" label="Заголовок" />
				<Field property="route" label="Путь к странице" />
				<div className="form-field">
					<Button onClick={this.switchMode}>{this.htmlMode ? 'WYSYWIG' : 'HTML'}</Button>
				</div>
				<Field property="text" label="Текст">
					<Editor
						mediaModel={store.model.Image}
						mediaProperty="filename"
						height={500}
					/>
				</Field>
			</Form>
		</>;
	}
	
}
